export default function Counter(baseNum) {
  this.innerCount = baseNum - 1;
  this.count = () => {
    this.innerCount += 1;
    return this.innerCount;
  };
}
